import ReactGA from 'react-ga4';

export const initGA = (measurementId: string): void => {
  ReactGA.initialize(measurementId);
};

export const logEvent = (category: string, action: string, label: string): void => {
  action = action.replaceAll(' ', '_').substring(0, 40);
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

export const logPageView = (path: string): void => {
  ReactGA.send({ hitType: 'pageview', page: path });
};
